import { StrictMode } from 'react';
import App from './App';
import './index.css';
import ReactDOM from 'react-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { plPL as gridPlPL } from '@mui/x-data-grid';
import { plPL as corePlPL } from '@mui/material/locale';
import { FarmContextProvider } from './store/farm-context';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

let theme = createTheme({
  typography: {
    fontFamily: `"Rajdhani", sans-serif`,
    fontSize: 17,
    fontWeightSemiBold: 600,
  },
  corePlPL,
  gridPlPL,
});

ReactDOM.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <FarmContextProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <App />
        </LocalizationProvider>
      </FarmContextProvider>
    </ThemeProvider>
  </StrictMode>,
  document.getElementById('root')
);
